import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { Capacitor } from '@capacitor/core';
import DashboardLayout from './pages/DashboardLayout';
import ChangePasswordPage from './pages/ChangePasswordPage';
import LandingPage from "./pages/LandingPage";
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import StockProfileAnalysis from "./pages/StockProfileAnalysis";
import ProfileAnalyzer from "./pages/ProfileAnalyzer";
import MarketAnalyzer from './pages/MarketAnalyzer';
import NewsAnalyzer from './pages/NewsAnalyzer';
import Pricing from './pages/Pricing';
import WatchlistPage from './pages/Watchlist';
import PrivateRoute from './components/PrivateRoute';
import Spinner from './components/Spinner';
import VerifyEmail from './pages/VerifyEmail';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  const { user, loading } = useAuth();

  // Show spinner while fetching user
  if (loading) return <Spinner />;

  return (
    <Routes>
      {/* Public routes */}
      <Route
        path="/"
        element={
          user ? (
            <Navigate to="/dashboard/NewsAnalyzer" />
          ) : Capacitor.isNativePlatform() ? (
            <Navigate to="/login" replace />
          ) : (
            <LandingPage />
          )
        }
      />
      <Route path="/login" element={user ? <Navigate to="/dashboard/NewsAnalyzer" /> : <Login />} />
      <Route path="/signup" element={user ? <Navigate to="/dashboard/NewsAnalyzer" /> : <Signup />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />

      {/* Protected dashboard routes */}
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="NewsAnalyzer" replace />} />
        <Route path="MarketAnalyzer" element={<MarketAnalyzer />} />
        <Route path="NewsAnalyzer" element={<NewsAnalyzer />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="watchlist" element={<WatchlistPage />} />
        <Route path="stock-profile-analysis" element={<StockProfileAnalysis />} />
        <Route path="ProfileAnalyzer" element={<ProfileAnalyzer />} />
        <Route path="change-password" element={<ChangePasswordPage />} />
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
